// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fd5925a6","453":"a06fdbaa","667":"72e85429"}[chunkId] + ".chunk.js";
};